import LayoutRoute from './LayoutRoute';

export default LayoutRoute;
